var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({on, attrs}){return [_c('span',_vm._g(_vm._b({staticClass:"elements--text",staticStyle:{"cursor":"text"}},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.text)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }